import * as React from 'react';
import { store } from '@pages/trucks/store/rootStore';
import './AreaBalancesTable.scss';
import { observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
import { IAreaBalance } from '@pages/trucks/store/BalancesStore';
import { Notify } from '@shared/ui-native/Notify';


@observer
export class AreaBalancesTable extends React.Component<{
    areaUuid: string;
    showStartingVolumes?: boolean;
}> {
    @observable.ref result: IAreaBalance = null;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.fetchBalances();
    }

    componentDidUpdate(prevProps: Readonly<{ areaUuid: string; showStartingVolumes?: boolean }>, prevState: Readonly<{}>, snapshot?: any) {
        if (this.props.areaUuid !== prevProps.areaUuid) {
            this.fetchBalances();
        }
    }

    fetchBalances() {
        store.balancesStore
            .fetch(this.props.areaUuid)
            .then(resp => {
                this.result = resp[0];
            })
            .catch(Notify.error);
    }

    render() {
        return (
            <>
                <table className='simple-table area-balances-table stats-table'>
                    <thead>
                        <tr>
                            <th style={{ borderRight: '1px solid #ccc' }}></th>
                            <th
                                colSpan={this.props.showStartingVolumes ? 2 : 1}
                                style={{ borderRight: '1px solid #ccc', textAlign: this.props.showStartingVolumes ? 'center' : 'left', padding: 0 }}
                            >
                                M3
                            </th>
                            <th
                                colSpan={this.props.showStartingVolumes ? 2 : 1}
                                style={{ borderRight: '1px solid #ccc', textAlign: this.props.showStartingVolumes ? 'center' : 'left', padding: 0 }}
                            >
                                {__('trucks.tons')}
                            </th>
                            <th colSpan={this.props.showStartingVolumes ? 2 : 1} style={{ textAlign: this.props.showStartingVolumes ? 'center' : 'left', padding: 0 }}>
                                {__('trucks.pieces')}
                            </th>
                        </tr>
                        {this.props.showStartingVolumes && (
                            <tr>
                                <th style={{ borderRight: '1px solid #ccc' }}>{__('trucks.trips.table_material')}</th>
                                <th>{__('trucks.starting_volumes.starting_value')}</th>
                                <th style={{ borderRight: '1px solid #ccc' }}>{__('trucks.starting_volumes.current_value')}</th>
                                <th>{__('trucks.starting_volumes.starting_value')}</th>
                                <th style={{ borderRight: '1px solid #ccc' }}>{__('trucks.starting_volumes.current_value')}</th>
                                <th>{__('trucks.starting_volumes.starting_value')}</th>
                                <th>{__('trucks.starting_volumes.current_value')}</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {this.result === null && (
                            <tr>
                                <td colSpan={7} className='text-center'>
                                    {__('js_logpoints.loading')}
                                </td>
                            </tr>
                        )}
                        {store.balancesStore.getAreaBalanceByMaterial(this.result?.balance).map(entry => {
                            const materialName = store.materials.getMaterialName(entry.materialId);
                            return (
                                <tr key={entry.materialId}>
                                    <td style={{ borderRight: '1px solid #ccc' }}>{materialName}</td>
                                    {this.props.showStartingVolumes && <td>{entry.initial[1]}</td>}
                                    <td style={{ borderRight: '1px solid #ccc' }}>{entry.current[1]}</td>
                                    {this.props.showStartingVolumes && <td>{entry.initial[2]}</td>}
                                    <td style={{ borderRight: '1px solid #ccc' }}>{entry.current[2]}</td>
                                    {this.props.showStartingVolumes && <td>{entry.initial[3]}</td>}
                                    <td>{entry.current[3]}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    {this.result?.balance?.length === 0 && (
                        <tfoot>
                            <td colSpan={7} className='text-center' style={{ fontSize: 14 }}>
                                {__('general.no_activity')}
                            </td>
                        </tfoot>
                    )}
                </table>
            </>
        );
    }
}
